"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DefaultFooter = _interopRequireDefault(require("./templates/DefaultFooter"));
var _LiteFooter = _interopRequireDefault(require("./templates/LiteFooter"));
var _SeaMythFooter = _interopRequireDefault(require("./templates/SeaMythFooter"));
var _SOLFooter = _interopRequireDefault(require("./templates/SOLFooter"));
var templates = {
  DefaultFooter: _DefaultFooter["default"],
  LiteFooter: _LiteFooter["default"],
  SeaMythFooter: _SeaMythFooter["default"],
  SOLFooter: _SOLFooter["default"]
};
var Footer = function Footer(props) {
  var TemplateSelected = templates[props.template];
  return /*#__PURE__*/_react["default"].createElement(TemplateSelected, props);
};
Footer.propTypes = {
  template: _propTypes["default"].string
};
Footer.defaultProps = {
  template: 'DefaultFooter'
};
var _default = exports["default"] = Footer;